import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './reducers'
import createSagaMiddleware from 'redux-saga'
import sagas from './sagas'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

const sagaMiddleware = createSagaMiddleware()

export default function (initialState = {}) {
	// Middleware and Enhancers
	const enhancers = [applyMiddleware(sagaMiddleware)]

	// Persisting state
	const persistConfig = {
		key: 'yhf',
		storage,
		stateReconciler: autoMergeLevel2,
	}
	const persistedReducer = persistReducer(persistConfig, rootReducer)

	const store = createStore(
		persistedReducer,
		initialState,
		compose(...enhancers)
	)
	const persistor = persistStore(store)

	sagaMiddleware.run(sagas)

	return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/store/store.prod.js